"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Class contain function wrapper for Service Encryption Public Key API
 * @public
 */
class ServiceEncryptionKey extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get list Public Key of service
     * @param serviceId - service Id
     * @param page - page number
     * @param limit - limit number
     * @returns list of Public Key in service
     */
    async getListPublicKey(serviceId, page = 0, limit = 10) {
        try {
            const data = await this._apiV2
                .serviceEncryptionKeyAPI
                .getListPublicKey(serviceId, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
   * Function to upload Service Encryption Public Key
   * @param file
   * @param serviceId
   * @returns
   */
    async uploadPublicKey(file, serviceId) {
        try {
            const data = await this._apiV2.uploadAPI.uploadPublicKey(file, serviceId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = ServiceEncryptionKey;
